export default __webpack_public_path__ + "static/slide-06 - copia-8614095acf98f4cac5f870920e337be0.jpg";